import { Box, Button, Grid, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { TEXT_TITLE_COLOR } from "../../constants/colors";
import AddIcon from '@mui/icons-material/Add';
import { useFormDialogMainController } from "./controller/form";
import { SuppliesMainGroupName } from "../../models/suppliesMain";
import ConfirmDialog from "../../components/ConfirmDialog";
import { useTranslation } from "react-i18next";

interface Props {
    onClose: VoidFunction;
    onfetchData: VoidFunction;
    selectedMain: SuppliesMainGroupName;
    onSetSelectedMain: Function;
}

export const MainCategoryForm = ({ onClose, onfetchData, selectedMain, onSetSelectedMain }: Props) => {
    const controllers = useFormDialogMainController({ selectedMain, onSetSelectedMain, onfetchData, onClose });
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const { t } = useTranslation('global');

    return (
        <form onSubmit={(e) => controllers.handleOpenForm(e)}>
            <Box sx={{ p: isSmallScreen ? 2 : 6 }}>
                <Box mb={isSmallScreen ? 1 : 2}>
                    <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight='bold'>
                        {selectedMain ? t("masterCategory_page.Update Main Category") : t("masterCategory_page.Create Main Category")}
                    </Typography>
                </Box>
                <Grid container spacing={isSmallScreen ? 1 : 2}>
                    <Grid item xs={12} sm={6}>
                        <Box
                            sx={{
                                p: isSmallScreen ? 2 : 4,
                                boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            }}
                        >
                            <Box sx={{ width: '100%', mt: isSmallScreen ? 1 : 2 }}>
                                <Box>
                                    <Typography>{t("masterCategory_page.MG CODE")}</Typography>
                                    <TextField fullWidth size="small" margin="normal" inputRef={controllers.mgCode} required />
                                </Box>
                            </Box>
                            <Box sx={{ width: '100%', mt: isSmallScreen ? 1 : 2 }}>
                                <Box>
                                    <Typography>{t("masterCategory_page.Name la")}</Typography>
                                    <TextField fullWidth size="small" margin="normal" inputRef={controllers.nameLa} required />
                                </Box>
                            </Box>
                            <Box sx={{ width: '100%', mt: isSmallScreen ? 1 : 2 }}>
                                <Box>
                                    <Typography>{t("masterCategory_page.Name en")}</Typography>
                                    <TextField fullWidth size="small" margin="normal" inputRef={controllers.nameEn} required />
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={isSmallScreen ? 12 : 6}>
                        <Box
                            mt={isSmallScreen ? 1 : 2}
                            sx={{
                                boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                                width: '100%',
                                height: '80%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: '#F4F6F8',
                            }}
                        >
                            <Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <label htmlFor="image-input">
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                background: '#EBEBEB',
                                                width: isSmallScreen ? 100 : 150,
                                                height: isSmallScreen ? 100 : 150,
                                                borderRadius: "10px",
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {controllers.imageToShow ? (
                                                <img src={controllers.imageToShow} style={{ width: isSmallScreen ? 100 : 200, height: isSmallScreen ? 100 : 200, borderRadius: '10px' }} alt='' />
                                            ) : (
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <AddIcon />
                                                    <Typography color={TEXT_TITLE_COLOR}>{t("masterCategory_page.Add Image")}</Typography>
                                                </Box>
                                            )}
                                        </Box>
                                    </label>
                                    <input
                                        type="file"
                                        id="image-input"
                                        onClick={(e: any) => {
                                            e.target.value = '';
                                        }}
                                        onChange={controllers.handleSelectImage}
                                        style={{ display: 'none' }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Box mt={isSmallScreen ? 1 : 2}>
                    {controllers.imageError && <Typography color="error">{controllers.imageError}</Typography>}
                    {controllers.errorMessage && <Typography color='error'>{controllers.errorMessage}</Typography>}
                </Box>
                <Box mt={isSmallScreen ? 4 : 2} sx={{ display: 'flex', justifyContent: isSmallScreen ? 'center' : 'end' }}>
                    <Button
                        variant='outlined'
                        color="error"
                        sx={{ textTransform: 'none', mr: isSmallScreen ? 1 : 2, width: 100 }}
                        onClick={() => { onClose(); controllers.handleReset(); }}
                    >
                        {t("masterCategory_page.Cancel")}
                    </Button>
                    <Button
                        variant="contained"
                        type="submit"
                        color="secondary"
                        sx={{ textTransform: 'none', color: '#fff', width: 150 }}
                    >
                        {selectedMain ? t("masterCategory_page.Update Category") : t("masterCategory_page.Create Category")}
                    </Button>
                </Box>
            </Box>
            <ConfirmDialog
                open={controllers.openConfirm}
                title={selectedMain ? t("masterCategory_page.Do you want to update this category ?") : t("masterCategory_page.Do you want to create this category ?")}
                loading={controllers.loadingConfirmButton}
                onCancel={controllers.handleCloseConfirm}
                onConfirm={() => controllers.handleSubmit()}
            />
        </form>
    )
}
